"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWrapper = exports.Steps = exports.StepperMobileControlsContainer = exports.StepperMobileControls = exports.StepWrapper = exports.StepContainer = exports.Step = exports.FunctionalStepper = exports.ErrorListItem = exports.ErrorListGroup = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreListItem = _interopRequireDefault(require("@legacy-vfuk/core-list-item"));

var _coreListGroup = _interopRequireDefault(require("@legacy-vfuk/core-list-group"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FunctionalStepper = _styledComponents["default"].div.withConfig({
  displayName: "FunctionalStepperstyle__FunctionalStepper",
  componentId: "sc-i1q3pv-0"
})(function (props) {
  var _ref = props.inverse ? props.functionalStepperTheme.appearance[props.appearance].inverse : props.functionalStepperTheme.appearance[props.appearance],
      color = _ref.color;

  return (0, _styledComponents.css)(["color:", ";"], color);
});

exports.FunctionalStepper = FunctionalStepper;
var Steps = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "FunctionalStepperstyle__Steps",
  componentId: "sc-i1q3pv-1"
})(function () {
  return (0, _styledComponents.css)(["width:100%;display:flex;"]);
});
exports.Steps = Steps;
var StepContainer = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "FunctionalStepperstyle__StepContainer",
  componentId: "sc-i1q3pv-2"
})(function (props) {
  var _ref2 = props.inverse ? props.functionalStepperTheme.appearance[props.functionalStepperAppearance].inverse : props.functionalStepperTheme.appearance[props.functionalStepperAppearance],
      stepBorderColor = _ref2.stepBorderColor;

  return (0, _styledComponents.css)(["display:flex;flex-grow:1;align-items:flex-start;justify-content:center;position:relative;[class*='InteractionListItem']{width:auto;&:focus{outline:none;box-shadow:none;}[class|='FunctionalStepperstyle__Step']{", "}}&::after{position:absolute;content:'';display:block;height:1px;margin-top:0;background-color:", ";transition:background-color 0.3s ease;", " top:", "px;left:calc(50% + ", "px);width:calc(100% - ", "px);", " ", " ", "}&:last-child{&::after{display:none;}}"], (0, _coreMixins.applyFocus)(), stepBorderColor, props.state && (0, _styledComponents.css)(["background-color:", ";"], props.inverse ? props.functionalStepperTheme.state[props.state].inverse.stepBorderColor : props.functionalStepperTheme.state[props.state].stepBorderColor), props.theme.spacing.responsive[8].sm / 2, props.theme.spacing.responsive[8].sm / 2, props.theme.spacing.responsive[8].sm, _coreMixins.respondTo.md((0, _styledComponents.css)(["top:", "px;left:calc(50% + ", "px);width:calc(100% - ", "px);"], props.theme.spacing.responsive[8].md / 2, props.theme.spacing.responsive[8].md / 2, props.theme.spacing.responsive[8].md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["top:", "px;left:calc(50% + ", "px);width:calc(100% - ", "px);"], props.theme.spacing.responsive[8].lg / 2, props.theme.spacing.responsive[8].lg / 2, props.theme.spacing.responsive[8].lg)), _coreMixins.respondTo.xl((0, _styledComponents.css)(["top:", "px;left:calc(50% + ", "px);width:calc(100% - ", "px);"], props.theme.spacing.responsive[8].xl / 2, props.theme.spacing.responsive[8].xl / 2, props.theme.spacing.responsive[8].xl)));
});
exports.StepContainer = StepContainer;

var StepWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FunctionalStepperstyle__StepWrapper",
  componentId: "sc-i1q3pv-3"
})(function () {
  return (0, _styledComponents.css)(["width:auto;text-align:center;display:flex;flex-direction:column;align-items:center;"]);
});

exports.StepWrapper = StepWrapper;

var Step = _styledComponents["default"].div.withConfig({
  displayName: "FunctionalStepperstyle__Step",
  componentId: "sc-i1q3pv-4"
})(function (props) {
  var _ref3 = props.inverse ? props.functionalStepperTheme.appearance[props.appearance].inverse : props.functionalStepperTheme.appearance[props.appearance],
      activeBackgroundColor = _ref3.activeBackgroundColor,
      defaultBackgroundColor = _ref3.defaultBackgroundColor,
      activeStepColor = _ref3.activeStepColor,
      stepBorder = _ref3.stepBorder,
      stepBorderColor = _ref3.stepBorderColor;

  return (0, _styledComponents.css)(["display:flex;align-items:center;justify-content:center;background-color:", ";border:", ";border-color:", ";border-radius:50%;", ";", ";text-align:center;transition:background-color 0.3s ease,border-color 0.3s ease;span{", ";}", " ", ""], defaultBackgroundColor, stepBorder, stepBorderColor, (0, _coreMixins.responsiveSizing)('width', 8), (0, _coreMixins.responsiveSizing)('height', 8), (0, _coreMixins.responsiveSizing)('line-height', 8), props.isCurrentStep && (0, _styledComponents.css)(["background-color:", ";color:", ";border:none;"], activeBackgroundColor, activeStepColor), props.state && (0, _styledComponents.css)(["border-color:", ";"], props.inverse ? props.functionalStepperTheme.state[props.state].inverse.stepBorderColor : props.functionalStepperTheme.state[props.state].stepBorderColor));
});

exports.Step = Step;

var TextWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FunctionalStepperstyle__TextWrapper",
  componentId: "sc-i1q3pv-5"
})(function (props) {
  return (0, _styledComponents.css)(["display:none;width:116px;", " ", " ", ""], _coreMixins.typography.paragraph(2, false), props.state && (0, _styledComponents.css)(["color:", ";"], props.inverse ? props.functionalStepperTheme.state[props.state].inverse.textColor : props.functionalStepperTheme.state[props.state].textColor), _coreMixins.respondTo.md((0, _styledComponents.css)(["display:block;"])));
});

exports.TextWrapper = TextWrapper;

var StepperMobileControlsContainer = _styledComponents["default"].div.withConfig({
  displayName: "FunctionalStepperstyle__StepperMobileControlsContainer",
  componentId: "sc-i1q3pv-6"
})(function () {
  return (0, _styledComponents.css)(["width:100%;"]);
});

exports.StepperMobileControlsContainer = StepperMobileControlsContainer;

var StepperMobileControls = _styledComponents["default"].div.withConfig({
  displayName: "FunctionalStepperstyle__StepperMobileControls",
  componentId: "sc-i1q3pv-7"
})(function () {
  return (0, _styledComponents.css)(["display:flex;align-items:center;justify-content:space-between;width:100%;>:only-child{margin:0 auto;}"]);
});

exports.StepperMobileControls = StepperMobileControls;
var ErrorListGroup = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "FunctionalStepperstyle__ErrorListGroup",
  componentId: "sc-i1q3pv-8"
})(function () {
  return (0, _styledComponents.css)(["text-align:center;", ";"], (0, _coreMixins.spacing)('margin-top', 2));
});
exports.ErrorListGroup = ErrorListGroup;
var ErrorListItem = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "FunctionalStepperstyle__ErrorListItem",
  componentId: "sc-i1q3pv-9"
})(function () {
  return (0, _styledComponents.css)(["", ";&:last-child{margin-bottom:0;}"], (0, _coreMixins.spacing)('margin-bottom', 2));
});
exports.ErrorListItem = ErrorListItem;
//# sourceMappingURL=FunctionalStepper.style.js.map